import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiFetch } from "../../lib/http";

export function ResetPasswordConfirmPage() {
  const { uidb64, token } = useParams();
  const nav = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [ok, setOk] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setOk(false);

    const resp = await apiFetch("/api/auth/password-reset/confirm/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uidb64,
        token,
        new_password1: p1,
        new_password2: p2
      })
    });

    const data = await resp.json().catch(() => ({}));
    if (!resp.ok) {
      setError(data?.error || "Reset failed.");
      setBusy(false);
      return;
    }

    setOk(true);
    setBusy(false);
    setTimeout(() => nav("/login"), 800);
  }

  return (
    <div className="container py-5">
      <div className="card shadow-sm" style={{ maxWidth: 520, margin: "0 auto" }}>
        <div className="card-body">
          <h1 className="h4">Choose a new password</h1>

          {error ? <div className="alert alert-danger">{error}</div> : null}
          {ok ? <div className="alert alert-success">Password updated. Redirecting to login…</div> : null}

          <form onSubmit={onSubmit}>
            <div className="mb-3">
              <label className="form-label">New password</label>
              <input className="form-control" type="password" value={p1} onChange={(e) => setP1(e.target.value)} required />
            </div>
            <div className="mb-3">
              <label className="form-label">Confirm new password</label>
              <input className="form-control" type="password" value={p2} onChange={(e) => setP2(e.target.value)} required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={busy}>
              {busy ? "…" : "Reset password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

